import c from '../common';

export default{

    //


    //Title and Tabs
    "DataCenterTitle": "數據中心",
    //"TradeRecord": "交易記錄",
    "Voucher": c.voucher.chn,
    "Discount": c.discount.chn,

    "Sales":"賣出",
    "Issue":"發行",
    "Transfer":"轉讓",
    "Redeem":"換領",
    "Discount":"優惠劵",


    "Bookings": "預約",
    "overview": "概覽",
    "AllRecord":"全部記錄",

    "Estamp": c.estamp.chn,
    "Earning": "賺取",
    "Transfer": "轉讓",
    "Redeem": "換領",
    "Consumer": c.consumer.chn,
    "Amount": "消費金額",
    "Point": "積分",
    "Transferor": "轉讓人",
    "Receiver": "接收人",
    "RedeemAmount": "換領數量",
    "PointDeducted": "扣減積分",
    "RedeemProduct": "已換領",
};